import React from "react";
import { dateDiff } from "../../../../_helpers/dateFormatter";
import { fixImageUrl } from "../../../../_helpers/fixImageUrl";

function JobCard({ jobItem, setLastElement, onJobApplyClick, index }) {
  return (
    <div className="col-md-6 mb-3" key={jobItem?.id} ref={setLastElement}>
      <div
        className="common-card p-4 bg-white border position-relative border-radius-10"
        key={jobItem?.id}
      >
        <div className="upper">
          <div className="d-flex mb-3 align-items-start">
            <img
              src={
                jobItem?.posted_by_details?.company_details?.logo
                  ? jobItem?.posted_by_details?.company_details?.logo
                  : "/assets/images/building-placeholder.png"
              }
              alt="company logo"
              className="border-radius-10 mr-3"
              style={{ width: "48px", height: "48px" }}
            />
            <div className="job-info">
              <h3
                className="font-weight-medium mb-1 text-capitalize cursor-pointer text-primary"
                onClick={() => onJobApplyClick(jobItem?.id, index)}
              >
                {jobItem.title}
              </h3>
              <p className="mb-1 fs-14 text-capitalize">
                <span className="text-muted">
                  {jobItem.job_details?.posted_by_details.company_details.name}
                </span>
              </p>
            </div>
            <div className="icon company-icon ml-auto text-center d-flex align-items-start">
              <span className="text-muted fs-smallest mr-3 pb-3 d-inline-block">
                Posted {dateDiff(jobItem.updated, new Date())} ago
              </span>
            </div>
          </div>
          <p className="skills-list">
            <span className="mr-2 font-weight-semi">Skills:</span>
            {Array.isArray(jobItem?.skill_names) &&
            jobItem?.skill_names &&
            jobItem?.skill_names.length > 1 ? (
              <>
                {jobItem?.skill_names &&
                  Array.isArray(jobItem?.skill_names) &&
                  jobItem?.skill_names.map((skill) => (
                    <span className="skill text-muted text-capitalize">
                      {skill}
                    </span>
                  ))}
                <p className="text-muted d-inline-block">
                  {Array.isArray(jobItem?.skill_names) &&
                  jobItem?.skill_names &&
                  jobItem.skill_names.length > 6
                    ? "..."
                    : null}
                </p>
              </>
            ) : (
              <span className="text-grey-4">Not Specified</span>
            )}
          </p>
          <div className="d-flex align-items-center fs-smallest text-primary mb-3">
            <p className="mb-0 bg-light-blue text-capitalize  rounded-lg py-1 px-3 mr-2">
              {jobItem?.employment_type ? (
                <>{jobItem?.employment_type.replace(/_/g, " ")}</>
              ) : (
                "Not Mentioned"
              )}
            </p>

            <p className="mb-0 bg-light-blue text-capitalize rounded-lg py-1 px-3 mr-2">
              {jobItem?.experience ? (
                <>{jobItem?.experience.replace(/_/g, " ")}</>
              ) : (
                "Not Mentioned"
              )}
            </p>
            <p className="mb-0 bg-light-blue text-capitalize bg-primary-light rounded-lg py-1 px-3 mr-2">
              Remote
            </p>
          </div>
        </div>
        <div className="card-bottom d-flex justify-content-between align-items-center mt-3 border-top pt-3">
          <p className="mb-0 mr-2 text-muted text-capitalize">
            {jobItem?.payment_from && jobItem?.payment_to ? (
              <>
                <span className="text-dark font-weight-medium">
                  <span className="mr-2 text-uppercase">
                    {jobItem?.payment_currency}
                  </span>
                  {jobItem?.payment_from}-{jobItem?.payment_to}
                </span>
                / {jobItem.payment_type}
              </>
            ) : (
              "Not Disclosed"
            )}
          </p>
          <div className="job-bottom d-flex align-items-center justify-content-between">
            <button
              className="btn btn-primary py-2"
              onClick={() => onJobApplyClick(jobItem?.id, index)}
            >
              View Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobCard;
